import React from 'react'
import {Box} from '@mui/material'
import {HEADER_HEIGHT_DESKTOP} from 'src/theme-new/tokens'
import UserMenu from 'src/components-new/shell/UserMenu'

// Static IA brand header for the portal-switch page: this page is reachable before
// a PSP scope is resolved (multi-scope users picking which portal to enter), so it
// intentionally shows the generic ItaliAssistenza logo rather than the PSP-specific
// one, and no nav/sidebar — but it still carries the user menu, like every other
// page's HeaderBar.
export default function ChangePortalHeaderNew(): JSX.Element {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        px: {xs: 2, md: 4},
        height: HEADER_HEIGHT_DESKTOP,
        flexShrink: 0,
        backgroundColor: '#fff',
        borderBottom: '1px solid',
        borderColor: 'divider',
      }}
    >
      <Box sx={{display: 'flex', alignItems: 'center', gap: {xs: 2, md: 4}}}>
        <Box component="img" alt="IA logo" src="/assets/images/logo_IA.png" sx={{height: 35}} />
      </Box>
      <UserMenu expanded={true} />
    </Box>
  )
}
